import { InfluencerProfileOverview, InfluencerProfileOverviewProps } from '../shared';

type InfluencerThreadsProfileOverviewProps = InfluencerProfileOverviewProps;

export const InfluencerThreadsProfileOverview = (props: InfluencerThreadsProfileOverviewProps) => (
  <InfluencerProfileOverview {...props} />
);
